const defaultData = {
  cheque: {
    id: null,
    franqueada: null,
    banco: null,
    atendente_usuario: null,
    pessoa: null,
    motivo_devolucao_cheque: null,
    titulo_pagar: null,
    titulo_receber: null,
    numero: null,
    titular: null,
    agencia: null,
    data_entrada: null,
    data_bom_para: null,
    data_baixa: null,
    data_devolucao: null,
    valor: null,
    situacao: 'P',
    complemento: null,
    observacao: null,
    excluido: null,
    tipo: 'R'
  }
}

export {
  defaultData
}
